var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "publish-goods-container" },
    [
      _c("div", [
        _c("h2", [
          _c(
            "span",
            {
              staticClass: "product-tips",
              on: {
                click: function($event) {
                  return _vm.$router.back()
                }
              }
            },
            [_vm._v("商品管理")]
          ),
          _vm._v(" / " + _vm._s(_vm.pageTitle))
        ])
      ]),
      _c("WenXinTips"),
      _c("BaseInfo", { ref: "baseInfoRef" }),
      _c("SaleInfoNormal", { ref: "saleInfoNormalRef" }),
      _c("DeliveryInfo", { ref: "deliveryInfoRef" }),
      _c("GraphicInfo", { ref: "graphicInfoRef" }),
      _c(
        "el-row",
        {
          staticStyle: { "margin-top": "20px" },
          attrs: { type: "flex", justify: "end" }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 14 } },
            [
              _c("el-button", { on: { click: _vm.cancelClick } }, [
                _vm._v("取消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("发布")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }